import {connect} from 'pwa-helpers';
import {css, LitElement} from 'lit';
import {property} from 'lit/decorators/property.js';
import {DecisionKind} from '@viamedici-spc/configurator-ts';

import store from '../../store';
import {selectSpcConfiguration, selectSpcConfigurations, selectSpcSession, selectSpcSessions} from '../../selectors';
import {pimText} from '../../util/values';


export class SpcBaseValue extends connect(store)(LitElement) {

	static styles = css`
	`;

	@property({type: Object})
	attribute = {};

	@property({type: Object})
	value = {};

	@property({type: String})
	state = 'Undefined';

	@property({type: Boolean})
	hideWhenDisabled = false

	@property( {type: String})
	displayStyle = null;

	@property({type: String})
	instance = 'default';

	constructor() {
		super();
		this.store = store;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.lang = state.status.lang;

		const isDefaultInstance = this.instance === 'default' || this.instance === undefined || this.instance === null;
		this.session = isDefaultInstance ? selectSpcSession(state) : selectSpcSessions(state)[this.instance];
		this.spcConfiguration = isDefaultInstance ? selectSpcConfiguration(state) : selectSpcConfigurations(state)[this.instance];
	}

	label() {
		return (this.value.isImplicit ? 'Impl: ' : '') + (this.value.name ?? this.value.id);
	}
	isIncluded() {
		return false;
	}
	isImplicit() {
		return this.value.decision?.kind === DecisionKind.Implicit;
	}

	isExcluded() {
		return this.selectedChoiceValueId !== this.value.id;
	}
	canBeIncluded() {
		return true;
	}

	canBeExcluded() {
		return true;
	}
	isVisible() {
		return this.hideWhenDisabled ? this.canBeIncluded() : true;
	}
	explanations() {
		return {};
	}

	hasExplanation() {
		return false;
	}

	async toggleDecision() {

	}

	getInfoText() {
		const display = pimText(this.lang, this.attribute.key, 'FV', this.spcConfiguration, this.translations, this.value.id);
		const short = pimText(this.lang, this.attribute.key, 'FV.S', this.spcConfiguration, this.translations, this.value.id);
		const long = pimText(this.lang, this.attribute.key, 'FV.L', this.spcConfiguration, this.translations, this.value.id);
		const info = long || short || '';
		return info !== display && !info.includes('[') ? info : '';
	}

	render() {
	}
}
